<script>
  import Materials from "./Materials.svelte";
  import { onMount } from "svelte";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import { link } from "svelte-spa-router";
  import Layout from "../../../Layout/Layout.svelte";
  import MenuHeading from "../../../shared/MenuHeading.svelte";
  import config from "../../../stores/config";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";

  let loading = true;
  let authData = { headers: { authorization: ls.get("jwt") } };

  export let params;

  let [orderID, styleID] = params.id.split("____");
  let materialReq = null;

  const loadData = async () => {
    loading = true;

    axios
      .get(`${$config.backendURL}/orders/${orderID}/${styleID}`, authData)
      .then((res) => {
        materialReq = res.data.materialReq;
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onMount(async () => {
    loadData();
  });
</script>

<svelte:head>
  <title>Material Requirements — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  <div class="py-2" />

  {#if loading}
    <div class="loading-screen h-screen flex items-center justify-center">
      <Wave size="100" color="rgb(244,162,97)" unit="px" />
    </div>
  {:else}
    <div class="flex justify-end mb-6">
      <a class="ml-3 btn btn-green-outline" use:link href={`/orders`}>
        <i class="fas fa-eye mr-3" />
        View All Orders
      </a>
      <button
        class="ml-3 btn btn-primary-outline"
        on:click={() => window.history.back()}
      >
        <i class="fas fa-arrow-left mr-3" />
        Return this Order
      </button>
    </div>

    <MenuHeading
      title="Material Requirements"
      description="Manage material requirements for this style "
    />

    <Materials
      {orderID}
      {styleID}
      {materialReq}
      on:reloadData={() => loadData()}
    />
  {/if}
</Layout>
